import { LegacyAppStateStoreService, ofType } from '@mode/legacy/util-domain';
import { SchedulesModalService } from '@mode/shared/ui-angularjs';
import { ScheduleActions } from '@mode/shared/schedules/domain';
import { WorkspaceSettingsDomainFacade } from '@mode/workspace-settings/domain';
import { from, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { Actions } from '~/actions';

export class ScheduleModalEffects {
  static $inject = ['actions$', 'RxStoreService', 'SchedulesModalService', 'WorkspaceSettingsDomainFacade'];

  constructor(
    private actions$: Observable<Actions>,
    private store: LegacyAppStateStoreService,
    private schedulesModalService: SchedulesModalService,
    private workspaceSettingsDomainFacade: WorkspaceSettingsDomainFacade
  ) {
    this.actions$
      .pipe(
        ofType(ScheduleActions.openScheduleModal, ScheduleActions.openWorkspaceSettingScheduleModal),
        switchMap(({ token, reportToken, type }) => {
          let orgWorkspaceUsername: string;
          if (type === ScheduleActions.openWorkspaceSettingScheduleModal.type) {
            orgWorkspaceUsername = this.workspaceSettingsDomainFacade.getCurrentOrgUsername();
          }
          return from(this.schedulesModalService.getSchedulesResources(reportToken, orgWorkspaceUsername)).pipe(
            map(({ owner, report, reportRun, schedules, account }) => ({
              account,
              report,
              reportOwner: owner,
              run: reportRun,
              schedule: schedules.find((schedule) => schedule.token === token),
            }))
          );
        })
      )
      .subscribe(({ account, report, run, schedule, reportOwner }) => {
        this.schedulesModalService.open({
          account,
          onSchedulesUpdate: () => this.store.dispatch(ScheduleActions.reloadSchedules()),
          report,
          reportOwner,
          run,
          schedule,
          view: 'edit',
        });
      });
  }
}
